import { didApiUrl } from '@/environment';
import { logger } from '@/services/logger';
import axios from 'axios';
import { CreateCampaignSessionPayload, PublicCampaign, UpdateCampaignSessionPayload } from '../types';

const axiosInstance = axios.create({
    withCredentials: false,
    baseURL: `${didApiUrl}/campaigns`,
    headers: {
        Accept: 'application/json',
    },
});

export const getCampaign = async ({ campaignId, clientKey }: { campaignId: string; clientKey: string }): Promise<PublicCampaign> => {
    const response = await axiosInstance.get(`/${campaignId}`, {
        headers: {
            Authorization: `Client-Key ${clientKey}`,
        },
    });

    return response.data;
};

export const createSession = async ({
    campaignId,
    clientKey,
    data,
}: {
    campaignId: string;
    clientKey: string;
    data: CreateCampaignSessionPayload;
}) => {
    const response = await axiosInstance.post<{ id: string }>(`/${campaignId}/sessions`, data, {
        headers: {
            Authorization: `Client-Key ${clientKey}`,
        },
    });

    return response.data.id;
};

export const sendAnalytic = async ({
    campaignId,
    clientKey,
    sessionId,
    data,
}: {
    campaignId: string;
    clientKey: string;
    sessionId: string;
    data: UpdateCampaignSessionPayload;
}) => {
    if (!sessionId || !sessionId.length) {
        logger.error(`Failed to send analytics for campaign: ${campaignId}`, new Error('Session ID is missing'));
        return;
    }

    await axiosInstance.patch(`/${campaignId}/sessions/${sessionId}/`, data, {
        headers: {
            Authorization: `Client-Key ${clientKey}`,
        },
    });
};
